import ApiService from "@/common/api.service";
import { SCHEMA, ERROR } from "./actions.type";

const actions = {
    [SCHEMA.GET](context, name) {
        return new Promise((resolve, reject) => {
            // set header to authorize
            ApiService.setHeader().then(() => {
                // fetch subscriptions
                ApiService.get("schemas", name)
                    .then(result => {
                        resolve(result);
                    })
                    .catch(e => {
                        context.commit(ERROR.SET, e);
                        reject(e);
                    });
            });
        });
    },
}
export default {
    actions
};
